(() => {
  const storageKey = "evp.garage.v2";
  // Local-only cap until vehicles are saved to customer accounts.
  const maxVehicles = 5;
  const handle = (value) =>
    String(value)
      .toLowerCase()
      .replace(/['’]/g, "")
      .replace(/[^a-z0-9_]+/g, "-")
      .replace(/^-|-$/g, "");
  async function initialize(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = "true";
    const form = root.querySelector("form");
    const [type, year, make, model] = ["type", "year", "make", "model"].map(
      (field) => form.querySelector(`[data-field="${field}"]`),
    );
    const submit = form.querySelector('[type="submit"]');
    const status = root.querySelector('[role="status"]');
    try {
      const response = await fetch(root.dataset.catalogUrl);
      if (!response.ok) throw new Error("Catalogue unavailable");
      const catalog = await response.json();
      let saved = null;
      try {
        saved = JSON.parse(localStorage.getItem(storageKey))?.selection;
      } catch (_) {}
      type.required = year.required = make.required = model.required = true;
      model.dataset.placeholder = "Select model";
      model.setAttribute("aria-label", "Model");
      year.setAttribute("aria-label", "Year");
      year.dataset.placeholder = "Select year";
      function options(select, values, preferred = "") {
        select.replaceChildren(new Option(select.dataset.placeholder, ""));
        values.forEach((value) => {
          // Temporary display correction; retain source values for tag filtering.
          const label =
            select === make && value === "Bodcat" ? "Bobcat" : value;
          select.add(new Option(label, value));
        });
        select.disabled = !values.length;
        select.value = values.includes(preferred) ? preferred : "";
      }
      const matchesYear = (model) =>
        model.years.some((value) => String(value) === year.value);
      function populate(index, preferred = "") {
        if (index === 0) options(type, Object.keys(catalog), preferred);
        if (index === 1)
          options(
            year,
            [
              ...new Set(
                Object.values(catalog[type.value] || {}).flatMap((make) =>
                  Object.values(make.models).flatMap((model) =>
                    model.years.map(String),
                  ),
                ),
              ),
            ].sort((a, b) => Number(b) - Number(a)),
            preferred,
          );
        if (index === 2)
          options(
            make,
            Object.entries(catalog[type.value] || {})
              .filter(([, make]) =>
                Object.values(make.models).some(matchesYear),
              )
              .map(([name]) => name)
              .sort((a, b) => a.localeCompare(b)),
            preferred,
          );
        if (index === 3)
          options(
            model,
            Object.entries(catalog[type.value]?.[make.value]?.models || {})
              .filter(([, model]) => matchesYear(model))
              .map(([name]) => name)
              .sort((a, b) => a.localeCompare(b, "en", { numeric: true })),
            preferred,
          );
        submit.disabled = !model.value;
      }
      [type, year, make, model].forEach((select, index) =>
        select.addEventListener("change", () => {
          for (let next = index + 1; next < 4; next++) populate(next);
          submit.disabled = !model.value;
        }),
      );
      populate(0, saved?.type || "SXS");
      populate(1, saved?.year);
      populate(2, saved?.makeName);
      populate(3, saved?.modelName);
      form.addEventListener("submit", async (event) => {
        event.preventDefault();
        if (!form.reportValidity() || !model.value) return;
        const modelKey = [type.value, make.value, model.value]
          .map(handle)
          .join("/");
        const key = modelKey + (year.value ? "/" + year.value : "");
        const selection = {
          key,
          source: "vehicle-data.json",
          type: type.value,
          makeName: make.value,
          modelName: model.value,
          make: handle(make.value),
          model: modelKey,
          year: year.value,
        };
        try {
          const garage = JSON.parse(localStorage.getItem(storageKey)) || {};
          // Vehicles are stored oldest first; keep only the most recent selections.
          const vehicles = [
            ...(Array.isArray(garage.vehicles) ? garage.vehicles : []).filter(
              (v) => v?.key !== key,
            ),
            selection,
          ].slice(-maxVehicles);
          localStorage.setItem(
            storageKey,
            JSON.stringify({ version: 2, active: key, selection, vehicles }),
          );
        } catch (_) {
          status.textContent =
            "Your browser could not save this vehicle. Filtering will still work.";
        }
        const collection =
          type.value === "ATV" ? "atv-tuning-accessories" : handle(type.value);
        const tags = [
          "make_" + handle(make.value),
          "model_" + handle(model.value),
        ];
        if (year.value) tags.push("year_" + year.value);
        // Both stores share this code, and not every store has every type
        // collection; filter all products rather than land on a 404.
        let collectionUrl = `${root.dataset.collectionsUrl}/${collection}`;
        try {
          const response = await fetch(collectionUrl, { method: "HEAD" });
          if (response.status === 404) {
            collectionUrl = `${root.dataset.collectionsUrl}/all`;
          }
        } catch (_) {}
        location.assign(`${collectionUrl}/${tags.join("+")}`);
      });
      root
        .querySelector("[data-derived-reset]")
        .addEventListener("click", () => {
          populate(0, "SXS");
          for (let index = 1; index < 4; index++) populate(index);
        });
    } catch (_) {
      status.textContent =
        root.dataset.error ||
        "Vehicle selection is unavailable. Please reload to try again.";
    }
  }
  const initializeAll = () =>
    document
      .querySelectorAll("[data-home-vehicle-selector]")
      .forEach(initialize);
  initializeAll();
  document.addEventListener("shopify:section:load", initializeAll);
})();
